let BaseURL =  process.env.REACT_APP_BASE_URL


const request = {
    login_user: BaseURL + "account/verify_user",
    logout: BaseURL+ "account/logoff",
    whoami: BaseURL + "account/whoami",
    get_user_app: BaseURL+ "srifin_connect/get_user_app",
    send_otp: BaseURL + 'account/send_otp',
    verify_otp : BaseURL + 'account/verify_otp',
    reset_password :BaseURL + 'account/reset_password',
    card_url : BaseURL
}


module.exports = {
    BaseURL,
    request,
};
